import React from 'react';

// Marketing stub for dual-host mode (REACT_APP_MARKETING_HOST) — rendered on
// the marketing domain instead of the app. Placeholder "Your product" copy a
// cloned app replaces; styled entirely with the kit's token/utility classes.

// Convention: the app lives on the app.* subdomain of the marketing host.
const APP_URL = process.env.REACT_APP_MARKETING_HOST
  ? `https://app.${process.env.REACT_APP_MARKETING_HOST}`
  : '/';

const FEATURES = [
  {
    name: 'Feature one',
    body: 'One sentence on the concrete outcome this delivers for the customer.',
  },
  {
    name: 'Feature two',
    body: 'One sentence on the second thing your product does unusually well.',
  },
  {
    name: 'Feature three',
    body: 'One sentence on why this beats the way people solve it today.',
  },
];

export default function Landing() {
  return (
    <>
      <nav className="cs-nav">
        <span className="cs-brand">your<span>product</span></span>
        <span className="cs-nav-spacer" />
        <a className="cs-btn cs-btn-outline cs-btn-sm" href={APP_URL}>Sign in</a>
      </nav>

      <div className="cs-page">
        <section className="u-stack u-center m-rise" style={{ '--gap': 'var(--sp-4)', textAlign: 'center', padding: 'var(--sp-12) 0' }}>
          <span className="cs-badge">Now in early access</span>
          <h1 className="u-balance" style={{ fontSize: 'var(--fs-3xl)', margin: 0, maxWidth: '18em' }}>
            Your product, in one clear sentence
          </h1>
          <p className="u-muted u-balance" style={{ fontSize: 'var(--fs-lg)', margin: 0, maxWidth: '36em' }}>
            A supporting line that says who it's for and what changes for them.
            Quiet, specific, no superlatives.
          </p>
          <div className="u-cluster" style={{ '--gap': 'var(--sp-3)', justifyContent: 'center' }}>
            <a className="cs-btn cs-btn-primary" href={APP_URL}>Get started</a>
            <a className="cs-btn cs-btn-outline" href="#features">Learn more</a>
          </div>
        </section>

        <section id="features" className="u-grid" style={{ '--gap': 'var(--sp-4)' }}>
          {FEATURES.map((f, i) => (
            <div key={f.name} className="cs-card m-rise" style={{ padding: 'var(--sp-5)', '--m-delay': `${i * 60}ms` }}>
              <h2 style={{ fontSize: 'var(--fs-lg)', margin: '0 0 var(--sp-2)' }}>{f.name}</h2>
              <p className="u-muted" style={{ margin: 0 }}>{f.body}</p>
            </div>
          ))}
        </section>

        <section className="cs-card m-reveal u-stack u-center" style={{ '--gap': 'var(--sp-3)', textAlign: 'center', padding: 'var(--sp-8)', marginTop: 'var(--sp-8)' }}>
          <h2 className="u-balance" style={{ fontSize: 'var(--fs-2xl)', margin: 0 }}>Ready when you are</h2>
          <p className="u-muted" style={{ margin: 0 }}>Sign in and see it working with your own data in minutes.</p>
          <a className="cs-btn cs-btn-primary" href={APP_URL}>Open the app</a>
        </section>

        <footer className="u-split u-small u-muted" style={{ marginTop: 'var(--sp-12)', paddingTop: 'var(--sp-4)', borderTop: '1px solid var(--border)' }}>
          <span>© {new Date().getFullYear()} Your product</span>
          <a href={APP_URL}>Console</a>
        </footer>
      </div>
    </>
  );
}
